import { render, staticRenderFns } from "./ExamContentPage.vue?vue&type=template&id=2fd04115"
import script from "./ExamContentPage.vue?vue&type=script&lang=js"
export * from "./ExamContentPage.vue?vue&type=script&lang=js"
import style0 from "./ExamContentPage.vue?vue&type=style&index=0&id=2fd04115&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports